import { render, staticRenderFns } from "./RegistroCartera.vue?vue&type=template&id=d131902c"
import script from "./RegistroCartera.vue?vue&type=script&lang=js"
export * from "./RegistroCartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports